/**
 * Gateway prefix for auth-service, read from the service's own swagger
 * `basePath: /auth-service` (auth-service `http/api/docs/swagger.yaml:1`). The
 * portal already calls `/auth-service/users/phone` and
 * `/auth-service/sessions` on this prefix.
 */
export const AUTH_SERVICE_API_PREFIX = '/auth-service';

/** The signed-in person: GET reads them, PATCH saves their own first and last name. */
export const USERS_ME_PATH = `${AUTH_SERVICE_API_PREFIX}/users/me`;
